import { ChevronDown } from 'lucide-react';
import { SiteContainer } from '../SiteUi';

const FAQ_ITEMS = [
  {
    question: 'Preciso instalar algum programa no computador?',
    answer:
      'Não. O AgilizaOS roda no navegador. A emissão fiscal também acontece por integração, sem instalador local.',
  },
  {
    question: 'O sistema emite NFC-e e NFS-e?',
    answer: 'Sim. A nota sai no fechamento da venda ou da OS. Se a internet cair, entra em contingência.',
  },
  {
    question: 'Funciona para mais de uma filial?',
    answer: 'Sim. Cada filial opera isolada. A matriz vê o consolidado.',
  },
  {
    question: 'Como o cliente volta sozinho?',
    answer:
      'Quando passa o intervalo configurado pela oficina, o AgilizaOS dispara o lembrete no WhatsApp.',
  },
  {
    question: 'Consigo migrar meus dados?',
    answer: 'Sim. Você envia clientes, veículos e produtos. A gente prepara a base.',
  },
  {
    question: 'Quanto custa?',
    answer: 'O valor depende da operação. A conversa começa no WhatsApp, sem checkout automático.',
  },
];

export function SiteFAQ() {
  return (
    <section id="faq" className="scroll-mt-24 py-20 sm:py-28">
      <SiteContainer className="max-w-3xl">
        <h2 className="font-display text-[clamp(2rem,4vw,3rem)] font-semibold tracking-tight text-[#16181d]">
          Dúvidas
        </h2>
        <div className="mt-10 divide-y divide-[#d9d4cc] border-y border-[#d9d4cc]">
          {FAQ_ITEMS.map((item) => (
            <details key={item.question} className="group py-1">
              <summary className="flex min-h-10 cursor-pointer list-none items-start justify-between gap-4 py-5 [&::-webkit-details-marker]:hidden">
                <span className="font-display font-semibold text-[#16181d]">{item.question}</span>
                <ChevronDown className="mt-1 h-4 w-4 shrink-0 text-[#5c5852] group-open:rotate-180" aria-hidden />
              </summary>
              <p className="pb-5 pr-8 text-sm leading-relaxed text-[#5c5852]">{item.answer}</p>
            </details>
          ))}
        </div>
      </SiteContainer>
    </section>
  );
}
